import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "skypeMsgCard" }
const _hoisted_2 = { class: "skypeMsgCard--header" }
const _hoisted_3 = { class: "skypeMsgCard--date" }
const _hoisted_4 = { class: "skypeMsgCard--content" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "skypeReverseClass"
}
const _hoisted_8 = {
  key: 1,
  class: "skypeReverseClass"
}

import { SkypeGetters, SkypeActions, SkypeMutations } from '@/store/modules/skype';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { skypeStaticUrl } from "@/requests";
import ReverseElementScroll from "@/utils/scrollerHijack";


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "SkypeMsgWindow",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const store = useStore();
const skypeMsgListContainRef = ref<HTMLElement | null>(null);
const skypeMsgListRef = ref<HTMLElement | null>(null);
onMounted(() => {
    const msgListElement = skypeMsgListRef.value; // 获取元素的引用

    if (msgListElement) {
        ReverseElementScroll(msgListElement)
    }
})
const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const skypeUserName = computed(() => {
    return store.getters[`skype/${SkypeGetters.getSkypeUserList}`];
})

const isMsgLoading = computed(() => {
    return store.getters[`skype/${SkypeGetters.getMsgsLoading}`];
});
const selectedConv = computed(() => {
    return store.getters[`skype/${SkypeGetters.getSelectedConv}`];
});
const currentPagination = computed(() => {
    return store.getters[`skype/${SkypeGetters.getMsgsPaginationByConvId}`](selectedConv.value);
});
const msgsGroup = computed(() => {
    return store.getters[`skype/${SkypeGetters.getMsgGroupByConvId}`](selectedConv.value);
});
const isCurrentMsgsAllLoaded = computed(() => {
    return store.getters[`skype/${SkypeGetters.getMsgsAllLoadedByConvId}`](selectedConv.value);
});
const disabled = computed(() => isMsgLoading.value || isCurrentMsgsAllLoaded.value);

const asyncGetMsgsByConvId = async (projId: string, convId: string, uid: string, userName: string, isAppend: boolean) => {
    await store.dispatch(`skype/${SkypeActions.asyncGetSkypeMsgs}`, { projId, convId, uid, userName, isAppend });
}
const shouldUpdate = computed(() => {
    return (!isMsgLoading.value && !isCurrentMsgsAllLoaded.value && selectedConv.value !== "");
});
const transferDateStrToLocalDateStr = (dateStr: string): string => {
    const date: Date = new Date(dateStr);
    return date.toLocaleString();
}

const handleScroll = () => {
    if (skypeMsgListRef.value !== null && skypeMsgListContainRef.value !== null) {
        return skypeMsgListRef.value.scrollTop + skypeMsgListContainRef.value.scrollHeight >= skypeMsgListRef.value.scrollHeight
    } else {
        return false
    }
}

const loadMsgs = () => {
    if (shouldUpdate.value && handleScroll()) {
        const projId = projectId.value;
        const userName = skypeUserName.value[0]
        const convId = selectedConv.value;
        const uid = targetId.value;
        asyncGetMsgsByConvId(projId, convId, uid, userName, true);
        store.commit(`skype/${SkypeMutations.setMsgsPaginationByConvId}`, { convId: convId, skypePagination: { ...currentPagination.value, page: currentPagination.value.page + 1 } });
    }
}

watchEffect(() => {
    // To fix a certain situation when infinite-loop is triggered once netxt time autoload would not be done immediately;
    if (shouldUpdate.value && msgsGroup.value.msgs.length === 0) {
        const projId = projectId.value;
        const userName = skypeUserName.value[0]

        const convId = selectedConv.value;
        const uid = targetId.value;
        asyncGetMsgsByConvId(projId, convId, uid, userName, true);
        store.commit(`skype/${SkypeMutations.setMsgsPaginationByConvId}`, { convId: convId, skypePagination: { ...currentPagination.value, page: currentPagination.value.page + 1 } });
    }
})


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "skypeMsgContainer",
    ref_key: "skypeMsgListContainRef",
    ref: skypeMsgListContainRef
  }, [
    _createElementVNode("div", {
      class: "skypeMsgs skypeReverseClass",
      ref_key: "skypeMsgListRef",
      ref: skypeMsgListRef,
      onScroll: loadMsgs
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(msgsGroup).msgs, (msg) => {
        return (_openBlock(), _createElementBlock("div", {
          key: msg.id,
          class: "skypeMsgContent skypeReverseClass"
        }, [
          (_openBlock(), _createElementBlock("div", {
            class: "skypeMsg",
            key: _unref(selectedConv) + msg.id
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", null, _toDisplayString(msg.displayName === "" ? msg.from : msg.displayName), 1),
                _createElementVNode("p", _hoisted_3, _toDisplayString(transferDateStrToLocalDateStr(msg.originalarrivaltime)), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                (msg.messagetype === 'RichText/UriObject')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_el_image, {
                        style: {"width":"70px","height":"70px"},
                        src: _unref(skypeStaticUrl) + msg.content.substring(53, 93) + '.jpg',
                        "preview-src-list": [_unref(skypeStaticUrl) + msg.content.substring(53, 93) + '.jpg'],
                        title: "点击查看大图"
                      }, null, 8, ["src", "preview-src-list"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(msg.content), 1))
              ])
            ])
          ]))
        ]))
      }), 128)),
      (_unref(isMsgLoading))
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "加载中......"))
        : _createCommentVNode("", true),
      (_unref(isCurrentMsgsAllLoaded))
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, "------已加载全部-------"))
        : _createCommentVNode("", true)
    ], 544)
  ], 512))
}
}

})